import React, { FC } from 'react';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import classNames from 'classnames/bind';

import type { RedesignLayoutProps } from './types';
import styles from './styles.pcss';

const theme = cnComponentsTheme('light');
const cn = classNames.bind(styles);

export const RedesignLayout: FC<RedesignLayoutProps> = ({ children }) => {
  const isElkFooter = window?.abTestChoices?.elkFooterEnabled;
  return (
    <div className={cn(theme, 'main', isElkFooter && 'no-bottom-padding')}>
      <div className={cn('content')}>{children}</div>
    </div>
  );
};
